import { format } from 'date-fns';

const INIT_STATE = {
  searchParams: {
    // page: 1,
    // size: 10,
    // sort: 'desc', // sortMethod
    startDate: format(new Date(), 'yyyyMMdd'),
    endDate: format(new Date(), 'yyyyMMdd'),
    customerName: '', // clientName
    compCd: 'ALL',
    searchName: '',
    pageConditionKey: '',
    pageCount: 10,
    pageNextYn: '',
  },
  isLast: false,
  mobileOmniList: [],
};

const mobileOmniListReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case 'MOBILE_OMNI/INIT_MOBILE_OMNI':
      return Object.assign({}, INIT_STATE, {
        searchParams: {
          ...INIT_STATE.searchParams,
          startDate: format(new Date(), 'yyyyMMdd'),
          endDate: format(new Date(), 'yyyyMMdd'),
        },
      });
    case 'MOBILE_OMNI/SAVE_SEARCH_PARAMS':
      return {
        ...state,
        searchParams: {
          ...state.searchParams,
          page: 1,
          [action.payload.params]: action.payload.value,
        },
      };
    case 'MOBILE_OMNI/SEARCH_MOBILE_OMNI_LIST_SUCCESS':
      return {
        ...state,
        mobileOmniList: action.payload.list,
        searchParams: {
          ...state.searchParams,
          pageConditionKey: action.payload.pageConditionKey,
          pageCount: action.payload.pageCount,
          pageNextYn: action.payload.pageNextYn,
        },
      };
    case 'MOBILE_OMNI/INFINITE_SEARCH_MOBILE_OMNI_LIST_SUCCESS':
      return {
        ...state,
        mobileOmniList: [...state.mobileOmniList, ...action.payload.list],
        isLast: action.payload.isLast,
        searchParams: {
          ...state.searchParams,
          pageConditionKey: action.payload.pageConditionKey,
          pageCount: action.payload.pageCount,
          pageNextYn: action.payload.pageNextYn,
        },
      };
    default:
      return state;
  }
};

export default mobileOmniListReducer;
